module.exports = __webpack_public_path__ + "img/sprout.d5a85bdf.svg";